<script setup lang="ts">
  defineProps({
    stretch: { type: Boolean, required: false, default: false },
    end: { type: Boolean, required: false, default: false },
    small: { type: Boolean, required: false, default: false },
    smaller: { type: Boolean, required: false, default: false },
  });
</script>
<template>
  <div class="btn-group" :class="{ stretch, end, small, smaller }">
    <slot />
  </div>
</template>
<style scoped lang="scss">
  .btn-group {
    display: flex;
    align-items: center;
    flex-direction: row;
    flex-wrap: wrap;
    min-width: 0;
    max-width: 100%;
    gap: 0.5rem;

    &.small {
      gap: 0.375rem;
    }

    &.smaller {
      gap: 0.125rem;
    }

    &.stretch {
      justify-content: space-between;
      width: 100%;
    }

    &.end {
      justify-content: flex-end;
      width: 100%;
    }
  }
</style>
